import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserChnlQuery } from 'src/app/home/userchnl/userchnl.query';
import { environment } from 'src/environments/environment';
import { ChannelService } from 'src/app/home/channel/channel.service';
import { SectionDataType } from 'src/app/core/enums/DataType';
import { StoreMode } from 'src/app/core/enums';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() showFooter: boolean;
  @Input() showMobileBottomNav: boolean;
  @Input() isFinishedLoading: boolean;

  buildVersion: string = environment.version;

  channel$ = new Subscription();
  sectionDataType = SectionDataType;
  homeSectionData: any;
  orderHistory: any;
  activeOrders: any;
  orderCount: number = 0;
  routerLinkHome = '';
  routerLinkReward = '';
  routerLinkOrder = '';
  routerLinkProfile = '';

  constructor(
    private channelService: ChannelService,
  ) { }

  ngOnInit(): void {
    this.channelService.get(StoreMode.Internal).subscribe((dt) => {
      if (dt) {
        this.homeSectionData = dt.data.channelHomeSections.slice();
        this.orderHistory = this.homeSectionData.filter(val => val.data.dataType === this.sectionDataType.OrderHistory)[0];

        if (this.orderHistory && this.orderHistory.data) {
          let dataInd = this.orderHistory.data.data.findIndex(dd => !!dd.dataSet);
          this.orderCount = dataInd > 0 ? this.orderHistory.data.data[dataInd].dataSet.length : 0;
        } else {
          this.orderCount = 0;
        }
      }
    });

    let pathSegments = this.channelService.getSegments();
    if (pathSegments) {
      this.routerLinkHome = [...pathSegments, 'home'].join('/');
      this.routerLinkReward = [...pathSegments, 'reward'].join('/');
      this.routerLinkOrder = [...pathSegments, 'my-order'].join('/');
      this.routerLinkProfile = [...pathSegments, 'profiles'].join('/');
    }
  }

  ngOnDestroy() {
    this.channel$?.unsubscribe();
  }
}
